// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3668g","signatureBlock":"Footer_signatureBlock__3uKmV","signature":"Footer_signature__1Jery"};